import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AlertController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { getToastPosition, getCountryCode, createRemoveAccountAlert, presentAlert } from '../../angular-wallet-base/utils';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppModeService } from '../../angular-wallet-base/services/app-mode.service';
import { TranslateService } from '@ngx-translate/core';
import parsePhoneNumber from 'libphonenumber-js';
import { MembersPortalService } from '../../angular-wallet-base/services/members-portal.service';
import { LodeUserFormDataService } from '../../angular-wallet-base/services/lodeuserformdata.service';
import { SubscriptionListenerComponent } from '../../angular-wallet-base/SubscriptionListenerComponent';
import { getServiceStatus } from 'src/app/angular-wallet-base/store/connection';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { ChangeFirstNameAction } from 'src/app/angular-wallet-base/actions/userData.actions';
import { DeleteAccountPage } from '../../../../src/app/views/delete-account/delete-account.page'
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { EMAILREGEX } from 'src/app/angular-wallet-base/constants';
@Component({
  selector: 'lode-user-form',
  templateUrl: './lode-user-form.component.html',
  styleUrls: ['./lode-user-form.component.scss'],
})

export class LodeUserFormComponent extends SubscriptionListenerComponent implements OnInit {
  @Input() isNewUser: boolean;
  @Output("cancelCreateAccount") cancelCreateAccount: EventEmitter<any> = new EventEmitter();
  
  separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Canada];
  
  public smsCode;
  public jwtToken;
  public showPwd: boolean = false;
  public isDesktopMode: boolean;
  public isLodeCreate: boolean = false;
  public isSMSConfirm: boolean = false;
  public emailUpdated: boolean = false;
  newUserForm: FormGroup;
  lodeUserForm: FormGroup;
  public countryList;
  public regionList = [];
  public lodeUser;
  public newUser;
  private loadingCreateAccount;
  private loadingUpdateAccount;
  private loadingValidatePhone;
  private showConfirmPwd;
  public services;
  public phone_country;

  public errorMessages = {
    username: [
      { type: 'required', message: ''},
      { type: 'minlength', message: ''},
      { type: 'maxlength', message: ''},
      { type: 'pattern', message: ''}
    ],
    fname: [
      { type: 'required', message: ''},
      { type: 'minlength', message: ''},
      { type: 'maxlength', message: ''},
      { type: 'pattern', message: ''}
    ],
    lname: [
      { type: 'required', message: ''},
      { type: 'minlength', message: ''},
      { type: 'maxlength', message: ''},
      { type: 'pattern', message: ''}
    ],
    email: [
      { type: 'required', message: ''},
      { type: 'email', message: ''}
    ],
    phone: [
      { type: 'required', message: ''},
      { type: 'minlength', message: ''},
      { type: 'maxlength', message: ''}
    ],
    prov: [
      { type: 'required', message: ''}
    ],
    city: [
      { type: 'required', message: ''}
    ],
    postal: [
      { type: 'required', message: ''}
    ],
    address: [
      { type: 'required', message: ''},
      { type: 'maxlength', message: ''}
    ],
    address2: [
      { type: 'maxlength', message: ''}
    ],
    password: [
      { type: 'required', message: ''},
      { type: 'minlength', message: ''},
      { type: 'pattern', message: ''}
    ],
    passwordConfirm: [
      { type: 'required', message: ''},
      { type: 'match', message: ''}
    ]
  };
  @ViewChild('phoneEle') phoneEle: any;
  selectedCountryISO = CountryISO.UnitedStates;

  constructor(private modal: ModalController,
              protected store: Store<AppState>,
              private nav: NavController,
              public formBuilder: FormBuilder,
              public appMode: AppModeService,
              private platform: Platform,
              private membersPortalService: MembersPortalService,
              private alertController: AlertController,
              private toast: ToastController,
              private translate: TranslateService,
              private lodeUserFormDataService: LodeUserFormDataService) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    this.lodeUserForm = this.formBuilder.group({
      fname: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(20),
        Validators.pattern('^[a-zA-Z]+$')
      ])),
      lname: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(20),
        Validators.pattern('^[a-zA-Z]+$')
      ])),
      email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(EMAILREGEX)
      ])),
      country: ['', Validators.required],
      prov: new FormControl('', Validators.compose([
        Validators.required
      ])),
      city: new FormControl('', Validators.compose([
        Validators.required
      ])),
      postal: new FormControl('', Validators.compose([
        Validators.required
      ])),
      address: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(30)
      ])),
      address2: new FormControl('', Validators.compose( [
        Validators.maxLength(30)
      ])),
      phone_verification: new FormControl(false),
      phone: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(14)
      ]))
    });
    this.lodeUserFormDataService.initialChangesOfForm = true;

    this.newUserForm = this.formBuilder.group({
      username: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
        Validators.pattern('^[a-zA-Z0-9_-]+$')
      ])),
      fname: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(20),
        Validators.pattern('^[a-zA-Z]+$')
      ])),
      lname: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(20),
        Validators.pattern('^[a-zA-Z]+$')
      ])),
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&]).{8,}')
      ])),
      passwordConfirm: new FormControl('', Validators.compose([
        Validators.required
      ])),
      email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.email
      ])),
      phone: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(14),
      ])),
      country: ['', Validators.required],
      phone_verification: new FormControl(true, Validators.required),
      is_company_account: new FormControl(false, Validators.required),
      list_newsletter: new FormControl(false, Validators.required),
      list_announce: new FormControl(false, Validators.required),
    }, {
      validator: this.passwordMatch
    });
     this.lodeUserForm.markAsPristine();
    this.lodeUserFormDataService.newUserForm = this.newUserForm;
    
    this.lodeUserFormDataService.lodeUserForm = this.lodeUserForm;

    this.subscriptions.add(this.lodeUserForm.valueChanges.subscribe(() => {      
      this.lodeUserFormDataService.lodeUserForm = this.lodeUserForm;
    }));

    this.subscriptions.add(this.newUserForm.valueChanges.subscribe(() => {
      this.lodeUserFormDataService.newUserForm = this.newUserForm;
    }));
  }
  async ngOnInit() {
    try {
        this.lodeUser = await this.membersPortalService.getUserInfo();
       this.countryList = await this.membersPortalService.getCountries();
       this.regionList = await this.membersPortalService.getRegions(this.lodeUser.country.id);
    
      // Older account does not have phone_country_code set properly so take it from user's country
      const phoneNumber = parsePhoneNumber(
        this.lodeUser.phone,
        this.lodeUser.phone_country_code ? this.lodeUser.phone_country_code.toUpperCase() : this.lodeUser.country.code.toUpperCase());
      if (this.lodeUser.phone_country_code) {
        this.selectedCountryISO = this.lodeUser.phone_country_code;
      }
      this.lodeUserForm.patchValue({
        fname: this.lodeUser.fname || '',
        lname: this.lodeUser.lname || '',
        email: this.lodeUser.email || '',
        phone: phoneNumber.format('E.164') || '',
        city: this.lodeUser.city || '',
        postal: this.lodeUser.postal || '',
        address: this.lodeUser.address || '',
        address2: this.lodeUser.address2 || '',
        phone_verification: this.lodeUser.phone_verification === 1,
      });

      if (this.lodeUser.country && this.lodeUser.country.id) {
        this.lodeUserForm.patchValue({
          country: this.lodeUser.country.id || ''
        });
      }
      if (this.lodeUser.prov && this.lodeUser.prov.id) {
        this.lodeUserForm.patchValue({
          prov: this.lodeUser.prov.id || ''
        });
      }

     this.subscriptions.add(this.store.select(getServiceStatus).subscribe(data => {
        this.services = data;
      }));

       setTimeout(() => {
        this.lodeUserForm.markAsPristine();
        this.lodeUserFormDataService.lodeUserForm = this.lodeUserForm;
       }, 100);
       this.lodeUserFormDataService.initialChangesOfForm = false;


    } catch (err) {
      // gotta wrap this in a trycatch or below statemets will not execute
      this.newUserForm.markAsPristine();
      this.countryList = await this.membersPortalService.getCountries();
    }
    await this.setErrorMsg();
  }

  async setErrorMsg() {
    this.errorMessages = {
      username: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.username_required').toPromise()
      },
        {
          type: 'minlength',
          message: await this.translate.get('lode_acc.error.username_minlength').toPromise()
        },
        {
          type: 'maxlength',
          message: await this.translate.get('lode_acc.error.username_maxlength').toPromise()
        },
        {
          type: 'pattern',
          message: await this.translate.get('lode_acc.error.username_invalid').toPromise()
        }],
      fname: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.fname_required').toPromise()
      },
        {
          type: 'minlength',
          message: await this.translate.get('lode_acc.error.fname_minlength').toPromise()
        },
        {
          type: 'maxlength',
          message: await this.translate.get('lode_acc.error.fname_maxlength').toPromise()
        },
        {
          type: 'pattern',
          message: await this.translate.get('lode_acc.error.fname_invalid').toPromise()
        }],
      lname: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.lname_required').toPromise()
      },
        {
          type: 'minlength',
          message: await this.translate.get('lode_acc.error.lname_minlength').toPromise()
        },
        {
          type: 'maxlength',
          message: await this.translate.get('lode_acc.error.lname_maxlength').toPromise()
        },
        {
          type: 'pattern',
          message: await this.translate.get('lode_acc.error.lname_invalid').toPromise()
        }],
      email: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.email_required').toPromise()
      },
        {
          type: 'email',
          message: await this.translate.get('lode_acc.error.email_invalid').toPromise()
        }],
      phone: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.phone_required').toPromise()
      },
        {
          type: 'minlength',
          message: await this.translate.get('lode_acc.error.phone_minlength').toPromise()
        },
        {
          type: 'maxlength',
          message: await this.translate.get('lode_acc.error.phone_maxlength').toPromise()
        }],
      city: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.city_required').toPromise()
      }],
      prov: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.state_required').toPromise()
      }],
      postal: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.postal_required').toPromise()
      }],
      address: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.address_required').toPromise()
      },
        {
          type: 'maxlength',
          message: await this.translate.get('lode_acc.error.address_maxlength').toPromise()
        }],
      address2: [{
        type: 'maxlength',
        message: await this.translate.get('lode_acc.error.address2_maxlength').toPromise()
      }],
      password: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.password_required').toPromise()
      },
        {
          type: 'minlength',
          message: await this.translate.get('lode_acc.error.password_minlength').toPromise()
        },
        {
          type: 'pattern',
          message: await this.translate.get('lode_acc.error.password_pattern').toPromise()
        }],
      passwordConfirm: [{
        type: 'required',
        message: await this.translate.get('lode_acc.error.passwordconfirm_required').toPromise()
      },
        {
          type: 'passwordMatch',
          message: await this.translate.get('lode_acc.error.passwordconfirm_match').toPromise()
        }]
    };
  }

  async onChangeCountry(e) {
    const id = e.target.value;

    if (!id) {
      this.regionList = [];
      return;
    }
    this.regionList = await this.membersPortalService.getRegions(e.target.value);
  }

  generateAvatarUrl() {
    return 'https://avatar.oxro.io/avatar.svg?&background=687984&color=fff&name=' + (this.lodeUser && this.lodeUser.fname ? this.lodeUser.fname.replace(/\s/g, '+') : 'Lode');
  }

  async removeAccount() {
    const handler = async () => {
      await this.membersPortalService.removeAccount();
      this.lodeUserForm.markAsPristine(); // Prevent deactivate guard from triggering
      await this.nav.navigateRoot('/wallet/assets',
          { skipLocationChange: true, replaceUrl: true, queryParams: { action: 'refresh' } });

    };

    await createRemoveAccountAlert(this.alertController, this.translate, handler,'lode_acc.remove_account.alert_title', 'lode_acc.remove_account.alert_description', 'lode_acc.remove_account.alert_cancel', 'lode_acc.remove_account.alert_accept');
  }

  async deleteAccount(){
    if(this.isDesktopMode){
      const modal = await this.modal.create({
        component: DeleteAccountPage,
        cssClass: 'delete-modal-css'
      });
      await modal.present();
    }else{
      this.nav.navigateForward(['delete-account']);
    }
  }

  toggleShowPwd() {
    this.showPwd = !this.showPwd;
  }

  toggleShowConfirmPwd() {
    this.showConfirmPwd = !this.showConfirmPwd;
  }

  async handleUpdateSubmit() {
    this.loadingUpdateAccount = true;

    try {
      const resUpdate: any = await this.membersPortalService.updateUserInfo(this.lodeUserForm.value);
      this.lodeUser.fname=resUpdate.data?resUpdate.data.fname:this.lodeUser.fname;
      this.lodeUser.lname=resUpdate.data?resUpdate.data.lname:this.lodeUser.lname;
      this.lodeUser.full_name=resUpdate.data?resUpdate.data.full_name:this.lodeUser.full_name;
      this.store.dispatch(new ChangeFirstNameAction(resUpdate.data.fname));

      this.emailUpdated = resUpdate.data.emailUpdated;
      if (this.lodeUserForm.get('phone_verification').dirty) {
        const res = await this.membersPortalService.updatePhoneVerification(this.lodeUserForm.value.phone_verification ? 1 : 0);
      }
      // added condition to check if the phone entered is unverified and not same.  
      if (this.lodeUserForm.value.phone_verification && (!this.lodeUser.phone_verified || (this.lodeUserForm.get('phone').dirty && (this.lodeUserForm.value.phone.number.replace(/ /g, "") != this.lodeUser.phone)))) {
        // NEW CODE 
        this.handleUpdatePhone();
        // If user's says the phone can be verified, AND the phone number hasn't been verified or the phone number has changed, do verify
        // const countrycode = getCountryCode(this.lodeUserForm.value.phone);
        // const res = await this.membersPortalService.updatePhoneNumberSMSSend(countrycode.phone, countrycode.countrycode.toLowerCase());
        this.isSMSConfirm = !this.isSMSConfirm;
      } else {
        const handler = async () => {
          this.lodeUserForm.markAsPristine();
        };
        const description = this.emailUpdated ? 'lode_acc.account_email_updated_description' : 'lode_acc.account_updated_description';
        await presentAlert(this.alertController, this.translate, handler, 'lode_acc.account_updated_title', description,'lode_acc.remove_account.alert_accept');
      }
      this.loadingUpdateAccount = false;
      this.lodeUserForm.markAsPristine();
    } catch (err) {
      this.loadingUpdateAccount = false;
      let msg;
      // THIS SHOULD BE FIXED WITH LODE TEAM TO ADD CODE FOR ERROR MESSAGE TO ENABEL MULTILANGUAGE ERROR MEESSAGES
      if (err.error.errors && err.error.errors[0] === 'The email has already been taken.') {
        msg = 'lode_acc.toast_msg.email_err_msg';
      } else if (err.error.errors.phone) {
        msg = 'lode_acc.toast_msg.phone_err_msg';
      } else {
        msg = 'lode_acc.toast_msg.update_err_msg';
      }
      this.presentToast('lode_acc.toast_msg.update_err_hdr', msg);
    }
  }

  async handleCreateAccount() {
    this.loadingCreateAccount = true;
    this.newUser = this.newUserForm.value;
    try {
      this.newUser.phone_country_code = this.newUser.country;
      this.newUser.phone = this.newUser.phone.number;
      
      this.newUser.gdpr_consent = '1';
      this.newUser.country = this.newUser.phone_country_code;
      const res = await this.membersPortalService.registerUser(this.newUser);
      this.loadingCreateAccount = false;
      this.newUserForm.markAsPristine();
      this.isLodeCreate = !this.isLodeCreate;
      const handler = async () => {
        await this.nav.navigateForward('/wallet/assets');
      };

      await presentAlert(this.alertController, this.translate, handler, 'lode_acc.account_created_title','lode_acc.account_created_description','lode_acc.remove_account.alert_accept');
    } catch (err) {
      this.loadingCreateAccount = false;
      let msg = 'lode_acc.toast_msg.registration_err_msg';
      if (err.error && err.error.errors) {
        if (err.error.errors.phone) {
          msg = 'lode_acc.toast_msg.phone_err_msg';
        } else if (err.error.errors.username && err.error.errors.email) {
          msg = 'lode_acc.toast_msg.email_username_err_msg';
        } else if (err.error.errors.username) {
            msg = 'lode_acc.toast_msg.username_err_msg';
        } else if (err.error.errors.email) {
            msg = 'lode_acc.toast_msg.email_err_msg';
        }
      }
      this.presentToast('lode_acc.toast_msg.registration_err_hdr', msg);
    }
  }

  // a validator to check that two fields match mainly for password and confirm password fields
  passwordMatch(control: AbstractControl) {
    const password: string = control.get('password').value; // get password from our password form control
    const passwordConfirm: string = control.get('passwordConfirm').value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== passwordConfirm) {
      // if they don't match, set an error in our confirmPassword form control
      control.get('passwordConfirm').setErrors({ passwordMatch: true });
    } else {
      control.get('passwordConfirm').setErrors(null);
    }    
  }

  async presentToast(hdr, msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000
    });
    await toast.present();
  }

  handleCancelClick() {
    this.nav.navigateBack('/wallet/settings');
  }

  async handleVerifyPhone() {
    this.loadingValidatePhone = true;
    try {
      await this.membersPortalService.phoneNumberSMSVerify(this.smsCode);
      this.loadingValidatePhone = false;
      const handler = async () => {
        await this.nav.navigateForward('/wallet/assets');
      };
      const description = this.emailUpdated ? 'lode_acc.account_email_updated_description' : 'lode_acc.account_updated_description';
      await presentAlert(this.alertController, this.translate, handler, 'lode_acc.account_updated_title', description,'lode_acc.remove_account.alert_accept');
    } catch (err) {
      this.loadingValidatePhone = false;
      this.presentToast('lode_acc.toast_msg.verifyphone_err_hdr', 'lode_acc.toast_msg.verifyphone_err_msg');
    }
  }

  async resendCode() {
    try {
      const countrycode = getCountryCode(this.lodeUserForm.value.phone);
      var validateResp = await this.membersPortalService.resendCode(countrycode.phone, countrycode.countrycode);
      if(validateResp.status == 200){
        const response = await this.membersPortalService.updatePhoneNumberSMSSend(countrycode.phone, countrycode.countrycode.toLowerCase());
        if(response == 'Success!'){
          this.presentToast('lode_acc.toast_msg.resend_ok_hdr', 'lode_acc.toast_msg.resend_code_msg');
        }else{
          throw new Error("");
        }
      }else{
        throw new Error("");
      }
    } catch (error){
      this.presentToast('lode_acc.toast_msg.resend_err_hdr', 'lode_acc.toast_msg.resend_err_msg');
    }
  }

  handleCancelVerify() {
    this.isSMSConfirm = !this.isSMSConfirm;
  }

  handleCancelCreateAccount (){
    this.cancelCreateAccount.emit();
  }
  
  memberPortalIsAvailable() {
    if (this.services) {
      return this.services.memberPortal;
    }

    return true
  }
  
  async handleUpdatePhone() {
    try {
      const res = await this.membersPortalService.updatePhoneNumberSMSSend(this.lodeUserForm.value.phone.number.trim(), this.lodeUserForm.value.phone.countryCode.toLowerCase());
    } catch (error) {    
      Logger.info(error);
    }
  }

}
